import React from 'react';
import Navbar from '../components/Navbar.js';
import Footer from '../components/Footer.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import "../App.css";


function TermsConditions() {
    return (
        <div>
            
            {/* Navbar */}

                <Navbar />

            {/* Navbar Ending */}

            {/* Page Content starts here */}
                <section className='terms-section'>
                    <div className='terms-container'>
                        <div className='terms-title'>
                            <p>Terms & Conditions</p>
                            <br />
                        </div>
                        <div className='terms-subtitle'>
                            <p>Please read our terms and conditions carefully to understand <br /> your rights and responsiblities while using our services.</p>
                            <br />
                        </div>

                        <div className='terms-content'>
                            <p>These terms and conditions outline the rules and regulations for the use of Caritas Matha Hospital's website. By accessing this website, you accept these terms and conditions. If you do not agree with all of the terms and conditions stated on this page, please do not continue to use Caritas Matha Hospital's website.</p>
                            <p>The following terminology applies to these Terms and Conditions : </p>


                            <ul>
                                <li>"User," "You," and "Your" refer to you, the person accessing this website and accepting the terms and conditions.</li>
                                <br />
                                <li>"Caritas Matha Hospital," "Ourselves," "We," "Our," and "Us" refer to our hospital, its employees, and affiliates.</li>
                            </ul>

                            <br />
                            <p className="content-title">Cookies</p>
                            
                            <p>We use cookies. By accessing Caritas Matha Hospital's website, you agree to use cookies in accordance with Caritas Matha Hospital's Privacy Policy. Most interactive websites use cookies to retrieve user details for each visit. Cookies are used by our website to enable the functionality of certain areas and make it easier for visitors. Some of our affiliate/advertising partners may also use cookies.</p>
                            <br />


                            <p className="content-title">License</p>
                            
                            <p>Unless otherwise stated, Caritas Matha Hospital and/or its licensors own the intellectual property rights for all material on Caritas Matha Hospital's website. All intellectual property rights are reserved. You may access this from Caritas Matha Hospital for your own personal use subject to restrictions set in these terms and conditions.</p>
                            <br />

                            <p className="content-title">You must not : </p>
                            <ul>
                                <li>Republish material from Caritas Matha Hospital</li>
                                <li>Sell, rent, or sub-license material from Caritas Matha Hospital</li>
                                <li>Reproduce, duplicate, or copy material from Caritas Matha Hospital</li>
                                <li>Redistribute content from Caritas Matha Hospital</li>
                            </ul>
                            <br/>

                            <p className="content-title">Hyperlinking to Our Content</p>
                            <p>The following organizations may link to our website without prior written approval : </p>
                            <ul>
                                <li>Government agencies</li>
                                <li>Search engines</li>
                                <li>News organizations</li>
                                <li>Online directory distributors</li>
                            </ul>
                            <p>These organizations may link to our home page, publications, or other website information as long as the link: (a) is not in any way deceptive; (b) does not falsely imply sponsorship, endorsement, or approval of the linking party and its products and/or services; and (c) fits within the context of the linking party's site.</p>

                            <p>If you are interested in creating a hyperlink to our website, you must notify us by sending an e-mail to Caritas Matha Hospital. Please include your name, your organization name, contact information, and the URL of your site, a list of any URLs from which you intend to link to our website, and a list of the URLs on our site to which you would like to link. Allow 2-3 weeks for a response.</p>

                            <p>By using our corporate name, you may also link to our homepage.</p>

                            <br />
                            <p className="content-title">iFrames</p>
                            
                            <p>Without prior approval and written permission, you may not create frames around our web pages that alter in any way the visual presentation or appearance of our website.</p>

                            <br />
                            <p className="content-title">Content Liability</p>
                            
                            <p>We shall not be held responsible for any content that appears on your website. You agree to protect and defend us against all claims that arise from your website. No link(s) should appear on any website that may be interpreted as libelous, obscene, or criminal, or which infringes, otherwise violates, or advocates the infringement or other violation of any third-party rights.</p>

                            <br />
                            <p className="content-title">Reservation of Rights</p>
                            
                            <p>We reserve the right to request that you remove all links or any particular link to our website. You approve to immediately remove all links to our website upon request. We also reserve the right to amend these terms and conditions and our linking policy at any time. By continuously linking to our website, you agree to be bound by and follow these linking terms and conditions.</p>

                            <br />
                            <p className="content-title">Removal of Links from Our Website</p>
                            
                            <p>If you find any link on our website that is offensive for any reason, you are free to contact us and inform us at any time. We will consider requests to remove links, but we are not obligated to do so or to respond to you directly.</p>

                            <br />
                            <p className="content-title">Disclaimer</p>
                            
                            <p>To the maximum extent permitted by applicable law, we exclude all representations, warranties, and conditions relating to our website and the use of this website. Nothing in this disclaimer will : </p>
                            <ul>
                                <li>Limit or exclude our or your liability for death or personal injury;</li>
                                <li>Limit or exclude our or your liability for fraud or fraudulent misrepresentation;</li>
                                <li>Limit any of our or your liabilities in any way that is not permitted under applicable law; or</li>
                                <li>Exclude any of our or your liabilities that may not be excluded under applicable law.</li>
                            </ul>

                            <br />
                            <p className="content-title">Contact Information</p>
                            
                            <p>If you have any additional questions or concerns regarding our policies, please email us at <a href="mailto:mail@caritashospital.org">mail@caritashospital.org</a>, and we will respond accordingly.</p>
                        </div>
                    </div>
                </section>
                <br />

            {/* Page content ends here */}

            {/* Footer */}

                <Footer />

            {/* Footer Ending */}

        </div>
    );
}

export default TermsConditions;